import type { ReactElement, MouseEvent } from 'react';
import { noop } from 'lodash-es';
import { useIntl } from 'react-intl';
import { StyledModal, StyledCloseButton } from './Modal.styles';
import Backdrop from './Backdrop/Backdrop';
import { Icon } from '../../atoms/Icon/Icon';
import { parseHtml } from '../../../utils/sanitiseHtml';

export interface ModalSessionType {
  title: string;
  href: string;
}

interface ModalProps {
  isPersistent?: boolean;
  onClose: (event: MouseEvent) => void;
}

export function DisabledModal({
  onClose,
  isPersistent = false,
  ...props
}: ModalProps): ReactElement {
  const intl = useIntl();
  return (
    <Backdrop onBackdropClick={isPersistent ? noop : onClose}>
      <StyledModal id="disabled-airport-modal" {...props}>
        <div
          dangerouslySetInnerHTML={parseHtml(
            intl.formatMessage({
              id: 'disabled-modal-message',
              defaultMessage:
                "<p><strong>FPO:</strong> We'd love to get you here, but please call <strong>1-800-I-FLY-SWA</strong> to see if you can book this route.</p>",
            }),
          )}
        />
        {!isPersistent && (
          <StyledCloseButton onClick={onClose}>
            <Icon.Close />
          </StyledCloseButton>
        )}
      </StyledModal>
    </Backdrop>
  );
}

export function DisabledModalConnection({
  onClose,
  isPersistent = false,
  ...props
}: ModalProps): ReactElement {
  const intl = useIntl();
  return (
    <Backdrop onBackdropClick={isPersistent ? noop : onClose}>
      <StyledModal id="disabled-airport-modal-connection" {...props}>
        <div
          dangerouslySetInnerHTML={parseHtml(
            intl.formatMessage({
              id: 'disabled-modal-connection-message',
              defaultMessage:
                "<p><strong>FPO:</strong> We'd love to get you here, but please call <strong>1-800-I-FLY-SWA</strong> to see if you can book this route.</p>",
            }),
          )}
        />
        {!isPersistent && (
          <StyledCloseButton onClick={onClose}>
            <Icon.Close />
          </StyledCloseButton>
        )}
      </StyledModal>
    </Backdrop>
  );
}
